export const CategoryNavigationModuleName = 'Category Navigation';
